export default __webpack_public_path__ + "static/media/game-img.3073723a.png";